import React from 'react'
import LeafletMap from '../Leaflet/Map'
import StompunktLayerContainer from './StompunktLayerContainer'
import TopowebbWMSLayer from './TopowebbWMSLayer'
import TopowebbNedtonadWMSLayer from './TopowebbNedtonadWMSLayer'
import OrtofotoWMSLayer from './OrtofotoWMSLayer'
import SelectWithPolygonLayerContainer from './SelectWithPolygonLayerContainer'
import * as basemaps from '../../constants/basemaps'

export default ({ basemap, ...leafletProps}) => (
	<LeafletMap {...leafletProps}>
		<Basemap map={basemap} />
		<StompunktLayerContainer />
		<SelectWithPolygonLayerContainer />
	</LeafletMap>
)

const Basemap = ({ map }) => {
	switch (map) {
		case basemaps.TOPOWEBB:
			return <TopowebbWMSLayer />
		case basemaps.TOPOWEBB_NEDTONAD:
			return <TopowebbNedtonadWMSLayer />
		case basemaps.ORTOFOTO:
			return <OrtofotoWMSLayer />
		default:
			return null
	}
}


// WEBPACK FOOTER //
// ./src/components/Map/Map.js